import types from './types';
import { getItemBadgeTotal as _getItemBadgeTotal } from '@/modules/tickets/api.js';

export default {
  async setLoading({ commit }, isLoading) {
    commit(types.SET_LOADING, isLoading);
  },
  async getBadgeCount({ commit }, businessId) {
    const { data } = await _getItemBadgeTotal(businessId);
    commit(types.SET_BADGE_TOTAL, data);
  },
};
